import React from "react";
var TailUp = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.34375 1.15625L12.8438 6.65625C13.0312 6.84375 13.0312 7.1875 12.8438 7.375C12.6562 7.5625 12.3125 7.5625 12.125 7.375L7.5 2.71875V14.5C7.5 14.7812 7.25 15 7 15C6.71875 15 6.5 14.7812 6.5 14.5V2.71875L1.84375 7.375C1.65625 7.5625 1.3125 7.5625 1.125 7.375C0.9375 7.1875 0.9375 6.84375 1.125 6.65625L6.625 1.15625C6.8125 0.96875 7.15625 0.96875 7.34375 1.15625Z",
  fill: "#1F1F1F"
}));
export default TailUp;